export default "__VITE_ASSET__DRCKPLYZ__"